import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  title: {
    height: 34,
    alignItems: 'flex-end',
    fontWeight: 300
  },
  subtitle: {
    alignItems: 'flex-end',
    fontWeight: 400,
    fontSize: 12
  },
  invalidOptionTitle: {
    height: 34,
    fontWeight: 300,
    paddingLeft: theme.spacing(2),
    paddingTop: theme.spacing(1),
    color: theme.colorPalette.white_10
  },
  invalidOptionSubtitle: {
    paddingLeft: theme.spacing(2)
  },
  footerContainer: {
    height: 98,
    background: theme.colorPalette.beige_10,
    boxShadow: '0px -1px 3px 0px rgba(0,0,0,0.2)'
  },
  footerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  scrollButton: {
    padding: theme.spacing(1.5, 4)
  },
  footerAlert: {
    background: theme.colorPalette.orange_10
  },
  floatingContainer: {
    position: 'fixed',
    left: 0,
    width: '100%',
    bottom: 0,
    zIndex: 150
  },
  footerContent: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    width: '100%',
    maxWidth: 1280,
    height: 98,
    margin: theme.spacing(0, 'auto')
  },
  btn: {
    padding: theme.spacing(0, 6),
    width: 260
  },
  wideBtn: {
    padding: theme.spacing(0, 6),
    width: 320
  },
  btnLabel: {
    fontWeight: 600,
    fontSize: 16
  },
  form: {
    display: 'flex',
    marginRight: theme.spacing(6)
  },
  formBtn: {
    backgroundColor: theme.colorPalette.orange_10,
    minWidth: 164,
    '&.MuiButton-contained.Mui-disabled': {
      color: theme.colorPalette.white_10,
      backgroundColor: theme.colorPalette.orange_10_op_70
    }
  },
  emailBtnLabel: {
    fontWeight: 500,
    fontSize: 14,
    paddingLeft: theme.spacing(0.5)
  },
  emailField: {
    paddingRight: theme.spacing(3),
    minHeight: 67
  },
  checkbox: {
    paddingRight: theme.spacing(3)
  },
  tooltipContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),
    marginTop: theme.spacing(1)
  },
  tooltip: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  tooltipText: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '20px',
    color: theme.colorPalette.orange_10,
    opacity: '60%'
  },
  copyLinksContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  copyLinkIcons: {
    marginRight: theme.spacing(1)
  },
  viewMoreButton: {
    height: 10
  },
  buttons: {
    padding: '0px 30px',
    marginRight: 20,
    marginBottom: 20
  },
  notificationContent: {
    color: 'black'
  },
  buttonContainer: {
    marginTop: 20
  },
  mainLabel: {
    margin: '20px 0px 10px 0px'
  },
  subLabel: {
    margin: '15px 20px 4px 0px '
  }
}));

export default useStyles;
